import React from 'react';
import { _$, _addClass } from '../../../../controllers/dom';
import { locales } from '../../../../translations/locales';
import Authorizations from './Authorizations';
import { NotificationManager } from 'react-notifications';

const NewRank = (props) => {
    const { locale, theme, ModuleRP } = props;
    const newRank = () => {
        if (!_$('rankName').value) {
            _addClass('rankName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        const newRank = {
            name: _$('rankName').value,
            authorizations: {
                bip: _$('bip').checked,
                radio: _$('radio').checked,
                planning: _$('planning').checked,
                operations: _$('operations').checked,
                alerts: _$('alerts').checked,
                config: false,
                superAdmin: _$('superAdmin').checked,
                admin: {
                    shop: {
                        new: _$('shop-new').checked,
                        manage: _$('shop-manage').checked,
                        delete: _$('shop-delete').checked,
                    },
                    players: {
                        new: _$('players-new').checked,
                        manage: _$('players-manage').checked,
                        delete: _$('players-delete').checked,
                    },
                    buildings: {
                        new: _$('buildings-new').checked,
                        manage: _$('buildings-manage').checked,
                        delete: _$('buildings-delete').checked,
                    },
                    vehicleModels: {
                        new: _$('vehicleModels-new').checked,
                        manage: _$('vehicleModels-manage').checked,
                        delete: _$('vehicleModels-delete').checked,
                    },
                    functions: {
                        new: _$('functions-new').checked,
                        manage: _$('functions-manage').checked,
                        delete: _$('functions-delete').checked,
                    },
                    skills: {
                        new: _$('skills-new').checked,
                        manage: _$('skills-manage').checked,
                        delete: _$('skills-delete').checked,
                    },
                    ranks: {
                        new: _$('ranks-new').checked,
                        manage: _$('ranks-manage').checked,
                        delete: _$('ranks-delete').checked,
                    },
                    status: {
                        new: _$('status-new').checked,
                        manage: _$('status-manage').checked,
                        delete: _$('status-delete').checked,
                    },
                    services: {
                        new: _$('services-new').checked,
                        manage: _$('services-manage').checked,
                        delete: _$('services-delete').checked,
                    },
                    incidents: {
                        new: _$('incidents-new').checked,
                        manage: _$('incidents-manage').checked,
                        delete: _$('incidents-delete').checked,
                    },
                    geographicSystem: _$('geographicSystem').checked,
                },
            },
        };
        let configAccess = false;
        for (const key in newRank.authorizations.admin) {
            if (Object.hasOwnProperty.call(newRank.authorizations.admin, key)) {
                const element = newRank.authorizations.admin[key];
                for (const value in element) {
                    if (Object.hasOwnProperty.call(element, value)) {
                        if (element[value]) {
                            configAccess = true;
                        }
                    }
                }
            }
        }
        if (configAccess) {
            newRank.authorizations.config = true;
        }
        ModuleRP.config.newRank(newRank);
    };

    return (
        <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
            <div className="card container p-0 gameInformations mt-5">
                <h5 className="card-header bg-primary">
                    {locales[locale].config.addNewRank}
                </h5>
                <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <form onSubmit={(event) => {
                        event.preventDefault();
                        newRank();
                    }}>
                        <div className='form-group'>
                            <label htmlFor='rankName'>
                                {locales[locale].config.rankName}
                                <span className='text-info m-1'>{locales[locale].config.required}</span>
                            </label>
                            <input
                                type='text'
                                id='rankName'
                                className='form-control w-100'
                                placeholder={locales[locale].config.rankName}
                            />
                        </div>
                    </form>
                    <form>
                        <div className='form-group'>
                            <label htmlFor='rankName'>
                                {locales[locale].config.authorizations}
                            </label>
                            <Authorizations theme={theme} locale={locale} />
                        </div>
                    </form>
                </div>
                <div className={`card-footer bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                    <button className='btn btn-primary float-right' id='btn-newRank' onClick={newRank}>{locales[locale].config.create}</button>
                </div>
            </div>
        </div>
    );
};

export default NewRank;
